import {useSelector} from 'react-redux';

import {getVisibleDomainChecks} from 'features/domain/lib/domainChecksView';
import {userSelector, hasTariffFlag} from 'entities/user';
import {isTranslate} from 'shared/lib/lang';
import {getDomainCheckFeatures, IDomainCheckFeature} from 'entities/monitor';

export interface IDomainCheckItem extends IDomainCheckFeature {
    enabled: boolean,
}

export const useDomainMonitorChecks = (activeKeys?: string[]): IDomainCheckItem[] => {
    const user = useSelector(userSelector);

    return getVisibleDomainChecks(getDomainCheckFeatures(), isTranslate(), activeKeys).map(check => ({
        ...check,
        enabled: hasTariffFlag(user, check.condition),
    }));
};

export default useDomainMonitorChecks;
